<template lang="html">
  <div class="col-lg-9 col-page-content page-style-1">

    <div class="row mt-0 box-candidates">

      <!-- Últimos perfiles guardados -->
      <div class="col-12 mt-0 col-candidates-list">
        <div class="row">

          <div class="col-12 mt-0 mb-4 box-acc-title-s1">
            <h4>Vacantes aplicadas</h4>
            <hr />
          </div>

         
          <!-- Resultados -->
          <div class="col-12 col-jobs-s4" v-if="$root.user.vacancies.length == 0">
              <p>No has aplicado a ninguna vacante</p>
          </div>
          <div class="col-12 col-jobs-s4" v-for="(job, hjbInx) in $root.user.vacancies" :key="'hjbInx-'+hjbInx" v-else>
            <div class="box">
     
              <div class="box-urgent" v-if="job.urgente_regular == 'urgente'">
                <span>URGENTE</span>
              </div>
              <div class="box-urgent" v-else-if="job.urgente_regular == 'regular'" style="background-color:#0e447b">
                <span>REGULAR</span>
              </div>

              <div class="col col-logo">
                <img :src="job.empresa_imageUrl">
              </div>

              <div class="col col-info">
                <h4 class="title">{{ job.name }}</h4>
                <h5><span class="company">
                  {{ job.company }}</span><br />
                  <i class="loc-icon"></i><span class="location">{{ job.town }},{{ job.state }}.</span>
                </h5>
                <h5 class="extra">Publicado hace {{job.hace_dias}} días. | {{job.area}}</h5>
              </div>

              <div class="col-12 col-line">
                <hr />
              </div>

              <div class="col col-salary">
                <p>{{job.sueldo}} / {{job.periodo}}</p>
              </div>
              <a class="btn-profile"  target="_blank" :href="'https://jobusco.com/#/empleos/'+job.empleos_id">
                  <i class="far fa-eye icon"></i>
                  <span>Ver vacante</span>
                </a>

              <div class="col col-buttons l-sm">
                <button class="btn _btn del"  @click="deletePostulate(job.id)">
                  <span class="icon"><i class="trans-250 far fa-trash-alt"></i></span>
                  <span class="txt">Eliminar</span>
                </button>
              </div>
            </div>
          </div>
          
          <!--  -->

          <!-- <div class="col-12">
            <div class="row pagination-container">
              <div class="col-12 col-pagination">
                <b-pagination
                  v-model="pagination.current_page"
                  :total-rows="pagination.total"
                  :per-page="pagination.per_page"
                  aria-controls="my-table"
                ></b-pagination>
              </div>
            </div>
          </div> -->

        </div>
      </div>
      <!--  -->
      <sweet-modal ref="modalLoading" hide-close-button blocking>

        <img src="/public/images/shared/loading.gif" width="30%">
        <p style="text-align: center;"><b>Cargando...</b></p>
    </sweet-modal>
    <sweet-modal ref="modalAlert" :icon="modal.icon">
        <p>{{modal.msg}}</p>
        <br><br>
        <a class="btn btn-info" @click="$refs.modalAlert.close()">Aceptar</a>
    </sweet-modal>
    </div>

  </div>
</template>

<script>
export default {
  data(){
    return{
      pagination:{
        current_page:1,
        order:0,
        per_page:10,
      },
      modal:{
          icon:null,
          msg:null
      }
    }
  },
  methods: {
      
      deletePostulate(id){
          var r = confirm("¿Esta seguro de eliminar esta postulacion?");
          if (r == true) {
              axios.delete(tools.url("/api/admin/deletePostulate/"+id))
              .then((response)=>{
                  this.modal.icon = 'success';
                  this.modal.msg = 'Postulacion eliminada correctamente';
                  this.$refs.modalAlert.open();
                  this.$root.auth();
              })
              .catch((error)=>{
                  this.modal.icon = 'error';
                  this.modal.msg = 'Ocurrio un error al eliminar';
                  this.$refs.modalAlert.open();
              });
          }
      }
  },
}
</script>
